import isPlainObject from 'lodash/isPlainObject.js';
import isString from 'lodash/isString.js';

import replaceStringVars from '../string/replaceStringVars.js';

import defaultStaticContent from './defaultStaticContent.js';

/**
 * Singleton for managing access to a static content object
 * set(source) : Content object can be set from @source object
 * get(key, vars) : Returns a value based on @key and optional @vars.
 * @key = 'aKey'
 * @vars = { varPlaceholderName: 'valueToReplacePlaceholderWith'}
 * If @key value is FALSEY the key is returned
 * If @key value is a string and @vars object is provided, the string is processed with replaceStringVars
 */

class StaticContent {
  constructor() {
    this.content = defaultStaticContent;
  }

  set(source = {}) {
    // console.warn('StaticContent set:', source);

    if (!isPlainObject(source)) {
      console.error('Expected object with key value pairs');
      return;
    }

    this.content = Object.assign({}, defaultStaticContent, source);
  }

  get(key, vars) {
    const hasVars = isPlainObject(vars);

    // if no value use the key
    const content = this.content[key];

    if (content && isString(content)) {
      // replace any string vars if supplied
      return hasVars ? replaceStringVars(content, vars) : content;
    }
    throw new Error(`Static Content key cannot be found: ${key}`);
  }

  add(source = {}) {
    this.content = Object.assign(this.content, source);
  }

  getContent() {
    return this.content;
  }
}

export default new StaticContent();
